<template>
  <div class="flex-page">
    <a-form
      class="form"
      :label-col="formItemLayout.labelCol"
      :wrapper-col="formItemLayout.wrapperCol"
    >
      <a-form-item label="拍品名称">
        <a-input
          type="text"
          style="width: 600px"
          v-model="form.name"
        ></a-input>
      </a-form-item>

      <a-form-item label="拍品图片">
        <UploadFile @callback="uploaded" :mult="false" folder="auction" />
        <a-input style="width: 600px" placeholder="请输入图片地址" v-model="form.thumb" />
      </a-form-item>

      <a-form-item label="拍品编号">
        <a-input
          type="text"
          style="width: 600px"
          v-model="form.sn"
        ></a-input>
      </a-form-item>

      <a-form-item label="起拍价">
        <a-input-number :min="0" v-model="form.price" /> 元
      </a-form-item>

      <a-form-item label="说明信息">
        <a-textarea
          style="width: 600px"
          :auto-size="{ minRows: 3, maxRows: 6 }"
          v-model="form.desc"
        />
      </a-form-item>
    </a-form>
    <div class="buttons">
      <a-button type="primary" @click="sub">添加拍品</a-button>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import UploadFile from '../../../components/uploadFile.vue'

export default {
  components: { UploadFile },
  data() {
    return {
      formItemLayout: {
        labelCol: {
          span: 3,
        },
        wrapperCol: {
          span: 20,
        },
      },
      form: {
        auc_id: null,
        name: "",
        thumb: '',
        sn: '',
        price: 1,
        desc: ""
      }
    };
  },
  created () {
    this.form.auc_id = this.$route.query.auc_id;
  },
  methods: {
    moment,
    uploaded(file) {
      this.form.thumb = file.file_path;
    },
    async sub() {
      if (!this.form.name) return this.$message.error('请填写拍品名称');
      if (!this.form.thumb) return this.$message.error('请上传拍品图片');
      if (!this.form.price) return this.$message.error('请填写起拍价');

      const r = await this.$axios.post("/auction/goods/create", this.form);

      if (r.status == 1) {
        this.$router.back()
      }
    }
  },
};
</script>